import { isNil } from 'ramda';
import headertemplate from './header.tpl.html';
import getStoredLanguage, { storeLanguage } from '../../utilities/language';

export class Header {
  constructor($scope, $ngRedux, actionsFactory, $timeout, $translate, $state, configService) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      $timeout,
      $translate,
      $state,
      configService,
    });
    const unsubscribe = $ngRedux.connect(this.mapStateToThis, actionsFactory)(this);
    $scope.$on('$destroy', unsubscribe);

    this.currentLang = null;
    this.langs = {
      it: 'ITA',
      en: 'ENG',
      es: 'ESP',
    };
  }

  $onInit() {
    this.selectedOption = {};

    this.profileOptions = [
      {
        text: 'NAVIGATION_ITEM_PROFILE_CHANGE_PASSWORD',
        state: 'authenticated.change-password',
      },
      {
        text: 'NAVIGATION_ITEM_PROFILE_LOGOUT',
        callback: () => {
          this.reqLogout();
        },
      },
    ];

    this.setLocaleMenu(getStoredLanguage());
  }

  /* eslint-disable */
  shouldShowPage(page) {
    return isNil(page.visible)
      ? true
      : page.visible;
  }

  pageHasDropdown(page) {
    return !isNil(page.dd);
  }
  /* eslint-enable */

  goTo(destination, params) {
    this.state(destination, params);
  }

  goToHome(isAuthenticated) {
    if (isAuthenticated) {
      this.state(this.navigation.home.state, this.navigation.home.params);
    } else {
      window.location.href = `${this.configService.FE_APP_PROTOCOL}://${this.configService.FE_APP_URL}`;
    }
  }

  dropdownOptionSelected(option) {
    if (option.callback) {
      option.callback(option);
    } else if (option.state) {
      this.state(option.state, option.params);
    }
  }

  isPageActive(page) {
    return page.dd
      ? page.dd
        .map(item => this.$state.includes(item.state, item.params))
        .reduce((isActive, isSubsectionActive) => isActive || isSubsectionActive, false)
      : false;
  }

  switchLang(lang) {
    storeLanguage(lang);
    this.updateLocale(lang);
    this.setLocaleMenu(lang);
    const state = this.$ngRedux.getState();
    const currentState = state.router.currentState.name;
    const pagesList = [
      'authenticated.company.detail.businessInfo',
      'authenticated.company.detail.techdoc',
      'authenticated.company.detail.questionnaire',
    ];

    this.$timeout(() => {
      if (pagesList.indexOf(currentState) === -1) {
        window.location.reload();
      }
    }, 0);
  }

  setLocaleMenu(locale) {
    this.currentLang = this.langs[locale];
  }

  /* eslint-disable */
  mapStateToThis(state) {
    return {
      auth: state.authentication,
      router: state.router,
      navigation: Object.assign({}, state.navigation),
    };
  }
  /* eslint-enable */
}

Header.$inject = [
  '$scope',
  '$ngRedux',
  'actionsFactory',
  '$timeout',
  '$translate',
  '$state',
  'configService',
];

export const header = {
  template: headertemplate,
  controller: Header,
};
